import { Button, Grid, Stack, Title } from '@mantine/core'
import LoomLogo from '@/assets/nzm-loom-logo.svg'
import { PageContainer } from '@shared/components/app-shell/page-container/page-container'
import { PAGE_TITLES } from '@/constants/page-titles'
import { useMsal } from '@azure/msal-react'
import { useNavigation } from '@/hooks/use-navigation'

export function LoggedOutPage() {
  const { instance } = useMsal()
  const { navigateToHome } = useNavigation()
  instance.clearCache()

  return (
    <PageContainer title={PAGE_TITLES.LOGGED_OUT}>
      <Stack p='lg' align='center'>
        <Title order={1}>
          <img src={LoomLogo} alt='Loom' />
        </Title>
        <Title order={2}>You are now logged out</Title>

        <Grid>
          <Button onClick={() => navigateToHome()}>Log back in</Button>
        </Grid>
      </Stack>
    </PageContainer>
  )
}
